
import { DefectModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import Page from '@/Page.vue';
import { Component, Ref } from 'vue-property-decorator';
import { Guid } from '@/libs/common/functions/guid';
import { cloneDeep } from 'lodash';
import { defectsStore } from '@/libs/defects/+state/store';

@Component({})
export default class DefectDialog extends Page {
    dialog = false;
    loading = false;
    saving = false;
    deleting = false;
    deleteDialog = false;
    valid = false;
    id = '';

    defect: DefectModel | null = null;
    defectOriginal: DefectModel | null = null;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.id == Guid.EmptyGuid();
    }

    requiredRule(v: any) {
        return !!v || (this.$t('validation.requiredField') as any);
    }

    open(id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close() {
        this.dialog = false;
    }

    private load(): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadDefect()
                    .then((e) => {
                        this.loading = false;
                        resolve(e);
                    })
                    .catch((e: any) => {
                        this.loading = false;
                        reject(e);
                    });
            });
        } else {
            this.defect = {
                id: Guid.EmptyGuid(),
                code: '',
                name: '',
            } as DefectModel;
            this.defectOriginal = cloneDeep(this.defect);
            return Promise.resolve();
        }
    }

    private loadDefect() {
        return new Promise((resolve, reject) => {
            defectsStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(defectsStore, CrudReponse.Get)
                .then((e) => {
                    this.defect = e;
                    this.defectOriginal = cloneDeep(e);
                    resolve(e);
                })
                .catch((e: any) => {
                    reject(e);
                });
        });
    }

    private save() {
        if (this.form.validate()) {
            const defect = { ...this.defect };
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                defectsStore.dispatch(CrudAction.Create, { item: defect });
                this.subscribe(defectsStore, CrudReponse.Create)
                    .then((e: DefectModel) => {
                        this.defect = e;
                        this.defectOriginal = cloneDeep(e);
                        this.id = e.id!;
                        this.saving = false;
                        this.$emit('saved', this.defect);
                        this.close();
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            } else {
                defectsStore.dispatch(CrudAction.Update, { item: defect });
                this.subscribe(defectsStore, CrudReponse.Update)
                    .then((e: DefectModel) => {
                        this.defect = e;
                        this.defectOriginal = cloneDeep(e);
                        this.saving = false;
                        this.$emit('saved', this.defect);
                        this.close();
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            }
        }
    }

    deleteClick() {
        this.deleteDialog = true;
    }

    deleteDefect() {
        this.deleting = true;
        defectsStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(defectsStore, CrudReponse.Delete)
            .then(() => {
                this.deleting = false;
                this.deleteDialog = false;
                this.close();
            })
            .catch(() => {
                this.deleting = false;
            });
    }
}
